import { render, staticRenderFns } from "./AnimatedCounter.vue?vue&type=template&id=86bb72ae"
import script from "./AnimatedCounter.vue?vue&type=script&lang=js"
export * from "./AnimatedCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports